// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Lo15","question":"styles_question__1H-gH","description":"styles_description__1TWTW"};